import { Cohort } from '@dtx-company/true-common/src/types/cohorts'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { useCohort } from './useCohort'

export type LimitCopy = 'Unlimited' | `${number}`

export interface LimitsCopy {
  codeLimit: LimitCopy
  pageLimit: LimitCopy
}

function getKeyForPlanType(planType: PlanType): Exclude<keyof Cohort, 'name'> {
  switch (planType) {
    case PlanType.FREE:
      return 'free'
    case PlanType.PRO:
      return 'pro'
    case PlanType.PRO_PLUS_ORG:
      return 'proPlus'
    case PlanType.PRO_FLEX:
      return 'proFlex'
    case PlanType.PILOT:
      return 'pilot'
    case PlanType.ENTERPRISE:
      return 'enterprise'
  }
}

export function useCohortLimits(planType: PlanType, isDefaultCohort?: boolean): LimitsCopy {
  const cohort = useCohort(isDefaultCohort)

  const key = getKeyForPlanType(planType)
  const limits = cohort[key]

  const codeLimit: LimitCopy = limits.codeLimit === Infinity ? 'Unlimited' : `${limits.codeLimit}`
  const pageLimit: LimitCopy = limits.pageLimit === Infinity ? 'Unlimited' : `${limits.pageLimit}`

  return {
    codeLimit,
    pageLimit
  }
}

export function useCohortLimitsByPlan({
  isDefaultCohort
}: {
  isDefaultCohort?: boolean
}): Record<PlanType, LimitsCopy> {
  const freeLimits = useCohortLimits(PlanType.FREE, isDefaultCohort)
  const proLimits = useCohortLimits(PlanType.PRO, isDefaultCohort)
  const proPlusOrgLimits = useCohortLimits(PlanType.PRO_PLUS_ORG, isDefaultCohort)
  const proFlexLimits = useCohortLimits(PlanType.PRO_FLEX, isDefaultCohort)
  const pilotLimits = useCohortLimits(PlanType.PILOT, isDefaultCohort)
  const enterpriseLimits = useCohortLimits(PlanType.ENTERPRISE, isDefaultCohort)

  return {
    [PlanType.FREE]: freeLimits,
    [PlanType.PRO]: proLimits,
    [PlanType.PRO_PLUS_ORG]: proPlusOrgLimits,
    [PlanType.PRO_FLEX]: proFlexLimits,
    [PlanType.PILOT]: pilotLimits,
    [PlanType.ENTERPRISE]: enterpriseLimits
  }
}
